const envConfigs = {
  dev: {
    MSAL_CLIENT_ID: "42db45f3-07a1-441e-a656-34e7fcfc85f5",
    MSAL_AUTHORITY: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47",
    BACKEND_ENDPOINT: "https://api.ppe.supplychain.microsoft.com/iamservice/preview",
    APPINSIGHTS_KEY: "cc56cd7a-da1d-4fac-96cf-a1c25f82f43e"
  },
  sit: {
    MSAL_CLIENT_ID: "42db45f3-07a1-441e-a656-34e7fcfc85f5",
    MSAL_AUTHORITY: "https://login.microsoftonline.com/72f988bf-86f1-41af-91ab-2d7cd011db47",
    BACKEND_ENDPOINT: "https://api.ppe.supplychain.microsoft.com/iamservice/preview",
    APPINSIGHTS_KEY: "cc56cd7a-da1d-4fac-96cf-a1c25f82f43e"
  },
  prod: {
    MSAL_CLIENT_ID: "42db45f3-07a1-441e-a656-34e7fcfc85f5",
    MSAL_AUTHORITY: "https://login.microsoftonline.com/prod-tenant-id-here",
    BACKEND_ENDPOINT: "https://api.ppe.supplychain.microsoft.com/iamservice/admin",
    APPINSIGHTS_KEY: "e1e2e3ee-9b41-44c0-afd6-2bbfc9abf998"
  },
};

// Determine the active environment
const env = process.env.REACT_APP_ENV || "dev"; // Default to dev
const config = envConfigs[env];

console.log(`current config: ${JSON.stringify(config.BACKEND_ENDPOINT)}`);
if (!config) {
  throw new Error(`Invalid environment: ${env}`);
}

export default config;
